<div class="step-container">

  <!-- Fase 1: Usa algum sistema? (Anota Aí, Cardápio Web, OlaClick) -->
  <ng-container *ngIf="fase === 'caminho-entrada' && !importando">
    <h2 class="step-titulo">Você já usa algum sistema?</h2>
    <p class="step-subtitulo">Selecione a plataforma para importar seu cardápio automaticamente.</p>

    <div class="plataformas-grid" [class.campo-shake]="shakePlataformas">
      <div class="plataforma-card"
           *ngFor="let p of plataformas"
           [class.selecionada]="plataformaSelecionada === p.id"
           (click)="selecionarPlataforma(p.id)">
        <img [src]="p.logo" [alt]="p.nome" class="plataforma-logo"
             [class.plataforma-logo-goomer]="p.id === 'goomer'"
             [class.plataforma-logo-wide]="p.id === 'instadelivery'">
        <span>{{ p.nome }}</span>
      </div>

      <div class="plataforma-card plataforma-card-nenhum"
           *ngIf="!plataformaSelecionada"
           (click)="nenhumSistema()">
        <div class="nenhum-icone-card"><i class="fe-plus-circle"></i></div>
        <span>Não uso nenhum</span>
      </div>
    </div>

    <div class="url-form mt-3" *ngIf="plataformaSelecionada">
      <div class="form-group mb-2">
        <label class="campo-label">Link da sua loja <span class="campo-obrigatorio">*</span></label>
        <input #linkInput type="text" class="campo-input"
               [(ngModel)]="url"
               [class.campo-shake]="shakeCampoLink"
               [placeholder]="placeholderAtual"
               (input)="erroValidacao = null"
               (keyup.enter)="prosseguir()">
        <p class="campo-dica"><i class="fe-info mr-1"></i>Abra a página da sua loja na plataforma e copie o endereço da barra do navegador.</p>
      </div>

      <p class="text-danger" *ngIf="erro">
        <i class="fe-alert-circle mr-1"></i> {{ erro }}
      </p>
    </div>

    <div class="step-actions">
      <button class="btn-anterior" (click)="onVoltar.emit()">
        <i class="fe-arrow-left mr-1"></i> Anterior
      </button>
      <div class="d-flex flex-column align-items-end">
        <p class="text-danger mb-1" *ngIf="erroValidacao">
          <i class="fe-alert-circle mr-1"></i> {{ erroValidacao }}
        </p>
        <button class="btn-proximo" (click)="prosseguir()">
          {{ plataformaSelecionada ? 'Importar e continuar' : 'Próximo' }} <i class="fe-arrow-right ml-1"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Fase 2: Pergunta sobre iFood -->
  <ng-container *ngIf="fase === 'ifood-pergunta' && !importando">
    <h2 class="step-titulo">Você usa iFood?</h2>
    <p class="step-subtitulo">Podemos importar seu cardápio diretamente de lá.</p>

    <!-- Opções Sim / Não (quando ainda não respondeu) -->
    <div class="ifood-opcoes" *ngIf="!plataformaSelecionada">
      <div class="ifood-opcao sim" (click)="confirmaIfood(true)">
        <img src="assets/icons/logo-ifood.png" alt="iFood" class="ifood-logo">
        <span>Sim, uso iFood</span>
      </div>
      <div class="ifood-opcao nao" (click)="confirmaIfood(false)">
        <i class="fe-x-circle"></i>
        <span>Não, não tenho iFood</span>
      </div>
    </div>

    <!-- Input de URL do iFood (após confirmar que tem) -->
    <div *ngIf="plataformaSelecionada === 'ifood'">
      <div class="ifood-confirmado mb-3">
        <img src="assets/icons/logo-ifood.png" alt="iFood" class="plataforma-logo" style="width:32px;height:32px">
        <span>iFood selecionado</span>
        <button class="btn-trocar" (click)="recusaIfood()">
          <i class="fe-x"></i> Trocar
        </button>
      </div>

      <div class="url-form">
        <div class="form-group mb-3">
          <label class="campo-label">Link da sua loja no iFood</label>
          <input #linkInput type="text" class="campo-input"
                 [(ngModel)]="url"
                 placeholder="Cole o link da sua loja no iFood"
                 (keyup.enter)="importar()">
        </div>

        <p class="text-danger" *ngIf="erro">
          <i class="fe-alert-circle mr-1"></i> {{ erro }}
        </p>
      </div>
    </div>

    <div class="step-actions">
      <button class="btn-anterior" (click)="voltarParaSistemas()">
        <i class="fe-arrow-left mr-1"></i> Anterior
      </button>
      <div class="d-flex flex-column align-items-end">
        <p class="text-danger mb-1" *ngIf="erroValidacao">
          <i class="fe-alert-circle mr-1"></i> {{ erroValidacao }}
        </p>
        <button class="btn-proximo"
                *ngIf="plataformaSelecionada === 'ifood'"
                [disabled]="!podeImportar"
                (click)="importar()">
          Importar e continuar <i class="fe-arrow-right ml-1"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Fase 3: Como quer montar o cardápio? -->
  <ng-container *ngIf="fase === 'caminhos' && !importando">
    <h2 class="step-titulo">Como você quer montar seu cardápio?</h2>
    <p class="step-subtitulo">Escolha a opção que melhor se encaixa na sua situação.</p>

    <div class="caminhos-lista" [class.campo-shake]="shakeCaminhos">
      <div class="caminho-card"
           *ngFor="let c of opcoesCaminho"
           [class.selecionado]="selecaoLocal === c.id"
           (click)="escolher(c.id)">

        <div class="caminho-icone">
          <i [class]="c.icone"></i>
        </div>

        <div class="caminho-info">
          <h3 class="caminho-titulo">{{ c.titulo }}</h3>
          <p class="caminho-descricao">{{ c.descricao }}</p>
        </div>

        <div class="caminho-check" *ngIf="selecaoLocal === c.id">
          <i class="fe-check"></i>
        </div>
      </div>
    </div>

    <div class="step-actions">
      <button class="btn-anterior" (click)="voltarParaIfoodPergunta()">
        <i class="fe-arrow-left mr-1"></i> Anterior
      </button>
      <div class="d-flex flex-column align-items-end">
        <p class="text-danger mb-1" *ngIf="erroValidacao">
          <i class="fe-alert-circle mr-1"></i> {{ erroValidacao }}
        </p>
        <button class="btn-proximo" (click)="confirmar()">
          Próximo <i class="fe-arrow-right ml-1"></i>
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Loading -->
  <div class="loading-area" *ngIf="importando">
    <div class="loading-spinner"></div>
    <p class="loading-texto">Buscando seu cardápio...</p>
    <p class="loading-subtexto">Isso pode levar alguns segundos</p>
  </div>
</div>
